// extracted by mini-css-extract-plugin
module.exports = {"createButton":"components-base-Button-Icons-CreateIconButton-CreateIconButton__createButton--Bperm"};